export default function About() {
  return (
    <section id="about" className="py-20 lg:py-28 bg-amber-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-5 gap-12 items-center">
          {/* Left Content */}
          <div className="lg:col-span-2">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-8 leading-tight">
              COMMITTED TO<br />YOUR PRIVACY
            </h2>

            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p>
                At EL VERDE S.R.L., we believe that privacy is a fundamental right. 
                Since our founding in Argentina, we've been dedicated to providing 
                enterprise-grade security solutions that protect individuals and 
                businesses from online threats.
              </p>

              <p>
                Our VPN service is built on a foundation of transparency, security, 
                and trust. We use military-grade encryption to ensure your data 
                remains private, and our strict no-logs policy means we never track 
                or store your online activity.
              </p>

              <p>
                With servers strategically located around the globe, we provide 
                fast, reliable connections that keep you secure without sacrificing 
                performance. Whether you're working remotely, traveling abroad, or 
                simply browsing at home, EL VERDE S.R.L. keeps you protected.
              </p>
            </div>

            <button className="mt-8 bg-orange-500 text-white px-8 py-3 rounded-full text-sm font-medium hover:bg-orange-600 transition-colors flex items-center space-x-2 whitespace-nowrap cursor-pointer group">
              <span>Learn Our Story</span>
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </button>
          </div>

          {/* Right Image */}
          <div className="lg:col-span-3">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/d49b7e80fab32d78d0f2c41e5d14b425.jpg"
                alt="EL VERDE S.R.L. Team"
                className="w-full h-full object-cover object-top"
              />
              
              {/* Location Badge */}
              <div className="absolute top-6 left-6 bg-white px-4 py-2 rounded-full shadow-lg">
                <div className="flex items-center space-x-2">
                  <i className="ri-map-pin-line text-orange-500"></i>
                  <span className="text-sm font-semibold text-gray-900">ARGENTINA</span>
                </div>
              </div>

              {/* Bottom Gradient Overlay */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-8">
                <p className="text-white text-lg font-medium">
                  Protecting digital privacy with passion and expertise
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
